<template>
  <div class="industry_zone">
    <div id="industry_zone" class="solid-1200px-width">
      <!-- 行业专区 - 物业 -->
      <IndustryZonePropertyManagement
        v-if="industryZoneData.id === INDUSTRY_ZONE_ID_MAP.PROPERTY_MANAGEMENT"
      />
    </div>
  </div>
</template>

<script>
import IndustryZonePropertyManagement from "@/components/LayoutHeaderSearch/components/IndustryZone/IndustryZonePropertyManagement";
import { INDUSTRY_ZONE_ID_MAP } from "@/utils/constants/constants.industry-zone";
export default {
  name: "IndustryZone",
  data() {
    return {
      INDUSTRY_ZONE_ID_MAP,
    };
  },
  components: {
    IndustryZonePropertyManagement,
  },
  computed: {
    industryZoneData() {
      return this.$store.getters["industryZone/industryZoneData"];
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/config";

.industry_zone {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;

  width: 100%;
  height: $industry-zone-height;
  padding-top: $layout-header-height;
  background: url("@/assets/img/SearchBar/bg-industry-zone.png") center center
    no-repeat;
  background-size: cover;
  color: white;
  font-weight: 600;

  .solid-1200px-width {
    width: $layout-body-width;
    height: 100%;
    margin: 0 auto;
    position: relative;
    display: flex;
  }
}
</style>
